/**
 * Return the single MOST SPECIFIC nav href that matches the current pathname — either an exact
 * match or a parent of the current path (`href` followed by `/`).
 *
 * A plain prefix match highlights a parent route (e.g. `/dashboard/intelligence`) even when a more
 * specific sibling nav item (e.g. `/dashboard/intelligence/weekly`) is the real destination, giving
 * two highlighted items. Picking only the longest match fixes that while still keeping a parent
 * highlighted for genuine sub-pages that aren't their own nav item (e.g. `/dashboard/editor/:id`).
 *
 * @param {string} pathname current location pathname
 * @param {string[]} hrefs the candidate nav hrefs
 * @returns {string|undefined} the most specific matching href, or undefined if none match
 */
export function mostSpecificNavMatch(pathname, hrefs) {
  return (hrefs || [])
    .filter((href) => pathname === href || pathname.startsWith(href + '/'))
    .sort((a, b) => b.length - a.length)[0];
}

export default mostSpecificNavMatch;
